import { inject, Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SitesService } from '@models/sites/sites.service';

import { GqlService, listPatientGroupsQuery, PatientGroupType } from '@shared/services/gql.service';
import { InvestigatorTransactionsService } from '@shared/services/investigator-transactions/investigator-transactions.service';
import { convertFilterToMap } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class InvestigatorTransactionsPageService {
  gqlService = inject(GqlService);
  investigatorTransactionsService = inject(InvestigatorTransactionsService);
  sitesService = inject(SitesService);

  getTransactionFilters() {
    return combineLatest([
      this.sitesService.get(),
      this.gqlService.listPatients$(),
      this.gqlService.listPatientGroups$([PatientGroupType.PATIENT_GROUP_STANDARD]),
      this.gqlService.listPatientProtocolVersions$(),
      this.gqlService.listPatientProtocolList$({
        include_manual: true,
        patient_protocol_types: [],
      }),
      this.gqlService.listPatientProtocolSubTypes$([]),
    ]).pipe(
      tap(
        ([
          siteList,
          patientList,
          patientGroupList,
          protocolVersionList,
          descriptionList,
          patientProtocolSubTypelist,
        ]) => {
          this.investigatorTransactionsService.siteMap = siteList?.data || [];
          this.investigatorTransactionsService.patientGroupMap =
            convertFilterToMap<listPatientGroupsQuery>(patientGroupList?.data || []);

          this.investigatorTransactionsService.setOptions({
            descriptionList,
            patientGroupList,
            patientList,
            patientProtocolSubTypeList: patientProtocolSubTypelist,
            protocolVersionList,
            siteList,
          });

          this.investigatorTransactionsService.setInMonthAdjustmentsFilters();
        }
      )
    );
  }
}
